module.exports = __webpack_public_path__ + "img/scene_fall_backlight@2x.ad6b3ac6.png";